/** String sorting function to bypass ascii */
export function sortStr(a: string, b: string) {
  const [stda, stdb] = [a.toLowerCase(), b.toLowerCase()];
  if (stda < stdb) return -1;
  if (stda === stdb) return 0;
  return 1;
}
